import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useEffect, useRef, useState } from "react";
import Order from "../../actions/order";
import Controls from "../controls/Controls";
import { Form, useForm } from "../customHelpers/useForm";
const initialFValues = {
  quantity: "",
  editing: false,
};
const useStyles = makeStyles((theme) => ({
  icon: {
    borderRadius: "50%",
    height: "40px",
    width: "40px",
  },
}));
const AddOrder = ({
  NotifyMessage,
  setOpenPopup,
  recordForEdit,
  getOrderData,
  edite,
}) => {
  useEffect(() => {
    if (recordForEdit !== null) {
      setValues({
        ...recordForEdit,
      });
    }
  }, []);

  const classes = useStyles();
 const {updateOrderProduct} = Order()

 
  const validate = (fieldValues = values) => {
    const temp = { ...errors };
    if ("quantity" in fieldValues)
      temp.paid =
        fieldValues.quantity.length !== 0 ? "" : "This field is required.";

    if ("quantity" in fieldValues) {
      temp.paid =
        fieldValues.quantity >= 0 ? "" : "Quantity Value must be More than 0.";
    }

    setErrors({
      ...temp,
    });
    if (fieldValues == values) return Object.values(temp).every((x) => x == "");
  };

  const { values, errors, setValues, handleInputChange, setErrors, resetForm } =
    useForm(initialFValues, true, validate);
 
  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      setValues({ ...values, submitting: true });

      delete values.logginError;
      delete values.editing;
      updateOrderProduct(values, values.id).then((data) => {
        if (data.err) {
          setValues({ ...values, submitting: false });
          NotifyMessage({
            message: data.err,
            type: "error",
          });
        } else {
          NotifyMessage({
            message: "Order successfully updated",
            type: "success",
          });
          setOpenPopup(false);
          resetForm();

          getOrderData()        }
      });
    }
  };
  return (
    <Form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="quantity"
            label="Quantity"
            value={values.quantity}
            onChange={handleInputChange}
            error={errors.quantity}
          />
        </Grid>

        <Grid item xs={12} md={6}></Grid>
        <Grid item xs={12} md={6}>
          <div>
            <Controls.Button
              disabled={values.submitting ? true : false}
              text={
                edite == true
                  ? values.submitting
                    ? "Editing..."
                    : "Done"
                  : values.submitting
                  ? "Adding..."
                  : "Add"
              }
              variant="contained"
              className="Button"
              type="submit"
            />
            <Controls.Button
              text={"Cancel"}
              variant="contained"
              className="Button"
              onClick={() => {
               setOpenPopup(false)
              }}
            />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
};

export default AddOrder;
